export const getMapBy = <T, U extends keyof T>(array: Array<T>, key: U): Map<T[U], T> => {
  const map = new Map();
  array.forEach((item) => map.set(item[key], item));
  return map;
};
